var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"star"},[_c('div',{staticClass:"yellow",style:(_vm.style)})])
}
var staticRenderFns = []

export { render, staticRenderFns }